export enum DialInType {
  FETCH_DIAL_IN_CODE = 'FETCH_DIAL_IN_CODE',
  FETCH_DIAL_IN_CODE_ERROR = 'FETCH_DIAL_IN_CODE_ERROR',
  FETCH_DIAL_IN_CODE_SUCCESS = 'FETCH_DIAL_IN_CODE_SUCCESS',
  FETCH_DIAL_IN_PHONE_NUMBERS = 'FETCH_DIAL_IN_PHONE_NUMBERS',
  FETCH_DIAL_IN_PHONE_NUMBERS_ERROR = 'FETCH_DIAL_IN_PHONE_NUMBERS_ERROR',
  FETCH_DIAL_IN_PHONE_NUMBERS_SUCCESS = 'FETCH_DIAL_IN_PHONE_NUMBERS_SUCCESS',
  SET_PARTICIPANT_CODE = 'SET_PARTICIPANT_CODE',
  SET_DIAL_IN_PHONE_NUMBERS = 'SET_DIAL_IN_PHONE_NUMBERS',
  SET_SELECTED_DIAL_IN_PHONE_NUMBER = 'SET_SELECTED_DIAL_IN_PHONE_NUMBER'
}
